import React from "react";
import Layout from "./Layout";
import homeHero from './assets/home_hero.jpg';

export default function Home() {
  return (
    <Layout>
      <div className="relative h-[400px] md:h-[500px] rounded-xl overflow-hidden shadow-lg mb-16">
        <img
          src={homeHero}
          alt="NextDME Software"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center text-white text-center px-6">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Software Built for DME Providers
          </h2>
          <p className="max-w-2xl text-lg mb-6">
            Simplify billing, streamline inventory, and stay compliant —
            all in one powerful platform.
          </p>
        </div>
      </div>
    </Layout>
  );
}